// extracted by mini-css-extract-plugin
export default {"loader":"Load_loader__Ogook","progress-circular-rotate":"Load_progress-circular-rotate__QnUgu","progress-circular-dash":"Load_progress-circular-dash__R-6YT"};